import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import flexColumns from '../../utils/flexColumns';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled(({
  isExpanded,
  replace = false,
  ...props
}) => (
  <Link replace={replace} {...props} />
))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 4.25rem;
  padding: ${themeResponsiveProperty(null, '0 1.5rem')};
  margin: ${themeResponsiveProperty('0 1rem', null)};
  ${({isExpanded}) => isExpanded
    ? css`border-bottom: ${themeResponsiveProperty('1px solid rgba(0,0,0,.27)' , null)};`
    : css`border-bottom: ${themeResponsiveProperty('1px solid transparent' , null)};`
};

  color: #000;

  ${({ columns }) => flexColumns(columns)};
  flex-wrap: ${themeResponsiveProperty('wrap', null)};
`;
